import controller from './family-plan-member.controller';
import familPlanController from './family-plan-member.controller';

export default {
  bindings: {
    type: '<'
  },
  controller ,
  template: require('./family-plan-member.html')
};



// WEBPACK FOOTER //
// src/app/family-plan/family-plan-member/family-plan-member.component.ts